import { Product } from 'utils/helpers/product';
import { products } from './products';

export * from './products';
export * from './marketplace-product';

export function getTestProducts(numProducts: number, defaultProducts?: Product[]): Product[] {
  const productSet = defaultProducts ?? products;
  return Array(numProducts)
    .fill(productSet[0])
    .map((product: Product, index: number) => ({
      ...product,
      id: String(index),
      Status: 'Active',
    }));
}
